import { cn } from "@repo/utils";

export default function LicenceProCnam() {
  return (
    <>
      <div className={cn("mb-20 flex items-center justify-between")}>
        <div className={cn("w-1/2")}>
          <img
            src="/images_pj/logo_cnam.png"
            alt="logo_cnam"
            width={300}
            height={200}
          />
        </div>
        <div className={cn("w-1/2 text-right text-2xl font-bold")}>
          Licence Professionnelle GRH, gestion des ressources humaines: gestion
          des rémunérations, en apprentissage et en formation continue
        </div>
      </div>

      <div className={cn("my-4 text-center text-2xl font-bold")}>
        Présentation de la formation
      </div>
      <div>
        {`Cette licence professionnelle a pour objectif de fournir aux étudiants
        les compétences nécessaires à l'administration du personnel, en
        particulier à`}{" "}
        <span>{`la gestion de la paie d'établissements de taille petite et moyenne.`}</span>
      </div>

      <div className={cn("mt-6")}>
        Compte tenu de la complexification croissante de la législation sociale
        et des techniques de paie, les entreprises souhaitent bénéficier de{" "}
        <span>spécialistes immédiatement opérationnels et autonomes.</span>{" "}
        {`Dans cette optique, cette licence professionnelle s'appuie sur la
        collaboration de nombreux professionnels et spécialistes du domaine. La
        finalité du diplôme est donc une`}{" "}
        <span>formation concrète </span> correspondant à un{" "}
        <span>besoin actuel</span> des entreprises.
      </div>

      <div className={cn("my-4 h-[2px] w-full bg-gray-300")}></div>

      <div className={cn("my-4 text-center text-2xl font-bold")}>
        Compétences visées
      </div>

      <div>
        {`Former des assistants en Ressources Humaines spécialisés en gestion de
        la paie capable de s'intégrer dans l'espace régional en développant
        plusieurs axes de compétences:`}
      </div>
      <ul className={cn("my-6 list-disc space-y-4 pl-12")}>
        <li>
          une <span> capacité technique </span>
          {`fondée sur la connaissance et la pratique d'outils et de méthodes
          utilisés dans les ressources humaines et la paie`}
        </li>
        <li>
          une <span>aptitude</span>{" "}
          {`à la communication et au travail d'interface
          avec les autres fonctions de l'entreprise`}
        </li>
        <li>
          une <span>{`capacité d'analyse`}</span> des problèmes liés à la gestion
          des rémunérations
        </li>
      </ul>

      <div className={cn("my-4 text-center text-2xl font-bold")}>
        Métiers visés
      </div>
      <ul className={cn("my-6 list-disc space-y-4 pl-12")}>
        <li>Responsable administration de la paie</li>
        <li>Collaborateur/Collaboratrice ou Technicien(ne) paie</li>
        <li>Responsable administratif et de gestion du personnel</li>
        <li>Assistant(e) Ressources Humaines</li>
      </ul>

      <div className={cn("my-4 text-center text-2xl font-bold")}>
        Déroulement des études
      </div>

      <div className={cn("font-bold")}>Pour le groupe en apprentissage :</div>
      <div className={cn("my-4")}>
        {`La Licence Professionnelle s'effectue en alternance
        Université-Entreprise par apprentissage, durant un contrat
        d'apprentissage établi sur 12 mois à compter de la rentrée universitaire
        de fin septembre pour les apprentis.`}
      </div>
      <div className={cn("font-bold")}>
        Pour le groupe en formation continue, financé par la Région :
      </div>
      <div className={cn("my-4")}>
        {`La Licence Professionnelle s'effectue en alternance
        Université-Entreprise durant 8 mois à compter de la rentrée
        universitaire de fin septembre. Elle se termine donc en mai.`}
      </div>

      <div className={cn("my-4 text-center text-2xl font-bold")}>
        Programme des enseignements
      </div>

      <div className={cn("font-bold")}>
        {`1/ Un premier bloc d'enseignements fondamentaux (120h) assure un triple
        objectif :`}
      </div>
      <ul className={cn("my-6 list-disc space-y-4 pl-12")}>
        <li>
          {`situer la gestion des rémunérations dans le système global de GRH de
          l'entreprise`}
        </li>
        <li>
          garantir un niveau suffisant dans les domaines linguistiques et
          informatique
        </li>
        <li>
          {`préparer l'étudiant de manière concrète à son insertion
          professionnelle`}
        </li>
      </ul>
      <div className={cn("font-bold")}>Enseignements Fondamentaux : 120 h</div>

      <table className={cn("my-16")}>
        <thead>
          <tr>
            <th className={cn("w-96 border-collapse border-8 border-double p-2")}>
              {`Unités d'enseignement`}
            </th>
            <th className={cn("w-96 border-collapse border-8 border-double p-2")}>
              Unités constitutives
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              F01 - Introduction à la GRH 60 h / 6 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>
                La fonction RH : rôles et dynamique actuelle - Gestion des
                postes
              </div>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>Gestion des compétences</li>
                <li>La formation comme outil de gestion</li>
                <li>{`Les techniques d'évaluation`}</li>
                <li>Le recrutement</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              F02 - Communication et insertion professionnelle 60 h / 6 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>Langue vivante (Anglais)</li>
                <li>NTIC & Outils informatiques</li>
                <li>Valorisation personnelle et intégration professionnelle</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <div className={cn("font-bold")}>
        {`2/Le second bloc d'enseignement (280h) décline les cours spécifiques à la spécialisation en gestion des rémunérations en développant les compétences suivantes : :`}
      </div>

      <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
        <li>
          {`connaître les instruments pratiques nécessaires à l'administration de
          la paie et maîtriser un logiciel de paie`}
        </li>
        <li>
          gérer les formes modernes de rétribution individuelles et collectives
        </li>
        <li>
          pouvoir traiter les charges sociales et fiscales et établir les
          déclarations fiscales liées au salaire
        </li>
        <li>
          suivre les évolutions de la législation du travail pour adapter de
          manière autonome le système de paie
        </li>
      </ul>
      <div className={cn("font-bold")}>
        Enseignements de Spécialisation en Gestion des Rémunérations : 280 h
      </div>

      <table className={cn("my-16")}>
        <thead>
          <tr>
            <th className={cn("w-96 border-collapse border-8 border-double p-2")}>
              {`Unités d'enseignement`}
            </th>
            <th className={cn("w-96 border-collapse border-8 border-double p-2")}>
              Unités constitutives
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              R01 - Droit de la Rémunération 50 h / 5 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>Statuts, conventions et accords</div>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>Spécificités individuelles et sectorielles</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              R02 - Pratique de la paie 60 h / 6 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>Les composantes du salaire</div>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>Le traitement des charges sociales et fiscales</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              R03 - Nouvelles formes de rémunération et contrats spécifiques 40
              h/ 4 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>Les périphériques de rémunération</div>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>{`Aides à l'embauche et contrats spécifiques`}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              R04 - Logiciels de paie 40 h / 4 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>{`Pratique d'un logiciel de gestion de paie (SAGE LIGNE 100)`}</div>
            </td>
          </tr>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              R05 - Politique de rétribution et pilotage de la masse salariale
              40 h / 4 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>{`Stratégie d'entreprise et stratégie de rétribution`}</div>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>{`Gestion budgétaire de la masse salariale`}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              R06 - Communication et dimension internationale de la rémunération
              50 h / 5 ECTS
            </td>
            <td className={cn("w-96 border-collapse border-8 border-double p-2")}>
              <div>
                Communication interne et externe des données de rémunération
              </div>
              <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
                <li>{`Préparation aux contrôles de l'URSSAF`}</li>
                <li>Anglais de la rémunération</li>
                <li>Gestion transfrontalière</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <div className={cn("font-bold")}>
        {`3/ Le projet tutoré (150h - 8 ECTS) et le rapport d'activité (12 ECTS) constituent le pôle pratique de la licence.`}
      </div>
      <div>
        {`Pour le projet tutoré, l'étudiant doit effectuer une proposition et
        évaluer ses retombées en réponse à un problème/manque de l'entreprise ou
        réaliser une synthèse la plus exhaustive possible sur un thème actuel et
        important dans le domaine de l'administration du personnel.`}
      </div>
      <div className={cn("my-4 italic")}>Exemples de projets possibles :</div>
      <ul className={cn("my-2 list-disc space-y-2 pl-12")}>
        <li>{`étude de l'attractivité externe du système de rétribution`}</li>
        <li>
          modalités de mise en place de nouvelles formes de rémunération
          collectives et/ou différées
        </li>
        <li>mise en place de tableaux de bords</li>
        <li>
          mise en conformité des pratiques de rémunération avec les évolutions
          légales récentes (DIF ... )
        </li>
      </ul>

      <div>
        {`L'étudiant doit de plus produire un `}
        <span>{`rapport d'activité`}</span>
        {` qui expose dans quelle mesure les buts d'intégration professionnelle ont été atteints durant l'alternance en entreprise.`}
      </div>

      <div className={cn("font-bold underline")}>COUTS : </div>
      <div>{`2600 euros (dont 200 euros de droits d'inscription universitaire)`}</div>

      <div className={cn("mt-12")}>
        Olivier MUSSO - Paul COUTERET - Responsables de formation CNAM Nancy
        Cedex 1 Tél. : +33 (0) 3 72 74 84 62 +33 (0) 3 72 74 84 56 Courriel :{" "}
        <button className={cn("text-blue-700 underline")}>
          iutmetz-lpremun-resp@univ-lorraine.fr
        </button>
      </div>
    </>
  );
}

LicenceProCnam.title = "Licence Pro GRH CNAM";
